import Users from '../views/users/list.vue'
export default [
  {
    path: '/users',
    name: "users",
    component: Users
  }
]